import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import {
	ProductCollectionContextProvider,
	useProductCollectionContext,
} from "vino/context/ProductCollectionsContext";
import ProductCollectionListItem from "./CollectionListItem";

const ProductCollectionList = () => {
	const { collections } = useProductCollectionContext();

	return (
		<div className="collection-filter-block px-10">
			<div className="mt-20">
				<Typography className="collection-block-title ">
					<span className="font-semibold">Collections</span>
				</Typography>
			</div>
			<List>
				{collections.map((collection) => (
					<ProductCollectionListItem
						key={collection.id}
						collection={collection}
					/>
				))}
			</List>
		</div>
	);
};

const ProductCollectionsListContainer = () => {
	return (
		<ProductCollectionContextProvider>
			<ProductCollectionList />
		</ProductCollectionContextProvider>
	);
};

export default ProductCollectionsListContainer;
